<!-- src/components/Breadcrumbs.vue -->
<template>
  <div class="com_breadcrumb1">
    <ul>
      <li v-for="item in breadcrumbsListData" :key="item.categoryId">
        <router-link
          v-if="dispTitle || (!dispTitle && item.categoryId != categoryId)"
          :to="`${item.categoryUrl}`"
          >{{ item.categoryName }}</router-link
        >
        <span v-else>{{ item.categoryName }}</span>
      </li>
      <li v-if="dispTitle">{{ dispTitle }}</li>
    </ul>
  </div>
</template>

<script lang="ts">
import { AxiosError } from "axios";
import { defineComponent, onMounted, ref } from "vue";
import { outputDebugLogs, formatMessage } from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import messages from "@/assets/messages.json";

interface BreadcrumbsItem {
  categoryId: string;
  categoryName: string;
  categoryUrl: string;
  parentCategoryId: string;
  parentCategoryName: string;
  parentCategoryUrl: string;
  level: number;
}

export default defineComponent({
  name: "BreadcrumbsComponent",
  props: {
    title: {
      type: String,
      required: true,
    },
    categoryId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const breadcrumbsListData = ref<BreadcrumbsItem[]>([]); // パンくずリストデータ
    const dispTitle = ref("");

    onMounted(async () => {
      outputDebugLogs("プロパティのカテゴリID: " + props.categoryId);
      outputDebugLogs("プロパティのタイトル " + props.title);

      try {
        dispTitle.value = props.title || "";
        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }
        }

        // パンくずリスト取得API
        const response = await apiAuthClient.post(
          "/api/Breadcrumbs/getBreadcrumbs",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            categoryId: props.categoryId,
          }
        );

        // レスポンスからパンくずリストデータを取得
        breadcrumbsListData.value = response.data.breadcrumbsList;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "パンくずリストデータの取得"));
      }
    });

    return {
      breadcrumbsListData,
      dispTitle,
    };
  },
});
</script>
